module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/2-5-7bb6aae955c8f7f8a39e6764ee75681e.png";